var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full px-4 sm:px-10 py-7"},[(!_vm.getUser)?_c('PoliciesListUserHasNotLoggedIn'):_c('PoliciesListUserPolicies')],1)}
var staticRenderFns = []

export { render, staticRenderFns }